import { FC, useEffect, useState } from "react";
import axios from "axios";
import useSWR, { mutate } from "swr";
import { TableColumn } from "react-data-table-component";
import { Modal } from "bootstrap";
import Swal from "sweetalert2";
import { useIntl } from "react-intl";
import { closestCenter, DndContext, KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Dropdown } from "rsuite";
import { DateRangePicker } from "rsuite";
import moment from "moment-timezone";
import Select from 'react-select'
import { useParams } from "react-router-dom";
import { Drawer, RadioGroup, Radio, ButtonToolbar, Button, IconButton, Placeholder } from 'rsuite';
import { DateRange } from "rsuite/esm/DateRangePicker";
import { ContentReportTerminProps, ReportTerminFilter, ReportTerminType } from "../../../interfaces/ReportTermin";
import { useTemplateFilterReportTermin } from "../../../stores/TemplateFilterReportTermin";
import { useDataTableStore } from "../../../stores/DataTableStore";
import useAccessToken from "../../../hooks/AccessToken";
import { usePipelineStore } from "../../../stores/PipelineStore";
import { useSettingsStore } from "../../../stores/SettingsStore";
import useUser from "../../../hooks/User";
import useCheckIsMobile from "../../../hooks/useCheckIsMobile";
import { useCustomeStore } from "../../../stores/CustomeStore";
import { SelectOption } from "../../../interfaces/SelectOption";
import usePredefinedRanges from "../../../hooks/PredefinedRanges";
import { LabelOption } from "../../../interfaces/Label";
import { updateSortTemplateFilterReportTermin, updateTemplateFilterReportTermin } from "../../../api/FilterTermin";
import { SelectDateFilterProps } from "../../../interfaces/Pipeline";
import useModalEffect from "../../../hooks/useModalEffect";
import { DataTableSelect } from "../../DataTable/DataTableSelect";
import ItemTemplateCompanyReportTermin from "./ItemTemplateCompanyReportTermin";
import ItemTemplatePersonalReportTermin from "./ItemTemplatePersonalReportTermin";
import { KTSVG } from "../../../_metronic/helpers";
import { Product } from "../../../interfaces/Product";
import { Merchant } from "../../../interfaces/Merchant";
import { InputCheckbox } from "../../Input/InputCheckbox";
import { ModifyTemplateReportTermin } from "../Template/ModifyTemplateReportTermin";
import { DeleteTemplateReportTermin } from "../Template/DeleteTemplateReportTermin";

interface FilterReportTerminMainProps {
    propsData: {
        updatedData: {
            manageColumns: TableColumn<ReportTerminType>[],
            updatedDataCompany: ReportTerminFilter[]
            updatedDataPersonal: ReportTerminFilter[]
        }
        setUpdatedData: {
            setManageColumns: React.Dispatch<React.SetStateAction<TableColumn<ReportTerminType>[]>>
            setUpdatedDataCompany: React.Dispatch<React.SetStateAction<ReportTerminFilter[]>>
            setUpdatedDataPersonal: React.Dispatch<React.SetStateAction<ReportTerminFilter[]>>
        }
        handleDragEnd: {
            handleDragEndColumn: (event: any) => void
            handleDragEndCompany: (event: any) => void
            handleDragEndPersonal: (event: any) => void
        }
        sensors: {
            sensorsColumn: any
            sensorsCompany: any
            sensorsPersonal: any
        }
        hasChanges?: {
            hasChangesCompany: boolean
            hasChangesPersonal: boolean
        }
        cancelChanges: {
            cancelChangesCompany: () => void
            cancelChangesPersonal: () => void
        }
        initializeData?: {
            initializeDataCompany: (data: any[]) => void
            initializeDataPersonal: (data: any[]) => void
        }
    }
    handleResetFilter: () => void
    selectAllColumn: boolean
    setSelectAllColumn: React.Dispatch<React.SetStateAction<boolean>>
    optionTypeDate: { value: string, label: string }[]
    selectTemplateIdPipeline: string
    setIsMounted: React.Dispatch<React.SetStateAction<boolean>>
}

const API_URL = process.env.REACT_APP_API_URL

const FilterReportTerminMain: FC<FilterReportTerminMainProps> = ({ propsData, handleResetFilter, selectAllColumn, setSelectAllColumn, optionTypeDate, selectTemplateIdPipeline, setIsMounted }) => {
    const { userTemplateFilterReportTermin, companyTemplateFilterReportTermin, setUserTemplateFilterReportTermin, setCompanyTemplateFilterReportTermin } = useTemplateFilterReportTermin()
    const { setMasterDateRange, masterDateRange, setTypeDateFilter, typeDateFilter, setSelectDateFilter, selectDateFilter, fetchCounter, setFetchCounter, clearMasterDateRange } = useDataTableStore()
    const { settings, setSettings } = useSettingsStore()
    const { selectedFilters, setSelectedFilter } = useDataTableStore();
    const token = useAccessToken()
    const { isMobile } = useCheckIsMobile()
    const user = useUser()
    const { companyId } = useCustomeStore()
    const [showModifyTemplateModal, setShowModifyTemplateModal] = useState<boolean>(false);
    const [showDeleteTemplateModal, setShowDeleteTemplateModal] = useState<boolean>(false);
    const [type, setType] = useState<string>("");
    const [productData, setProductData] = useState<SelectOption[]>([]);
    const [merchantData, setMerchantData] = useState<SelectOption[]>([]);
    const [template, setTemplate] = useState<ReportTerminFilter>({} as ReportTerminFilter);
    const intl = useIntl()
    const paidTerminDataOption = [{value:"PAID",label:intl.formatMessage({id:"FORM.LABEL.PAID"})},{value:"UNPAID", label:intl.formatMessage({id:"FORM.LABEL.UNPAID"})}]
    const predefinedRanges = usePredefinedRanges()

    const [isOpenDrawer, setIsOpenDrawer] = useState(false);

    const selectConfigs = [
        {
            placeholder: `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "FORM.LABEL.MERCHANT" })}`,
            tableKey: 'reportTermin',
            filterKey: 'merchantName',
            options: merchantData,
            onChange: (values: string[]) => setSelectedFilter('reportTermin', 'merchantName', values)
        },
        {
            placeholder: `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "FORM.LABEL.TERMIN_PAYMENT_STATUS" })}`,
            tableKey: 'reportTermin',
            filterKey: 'tanggalPembayaran',
            options: paidTerminDataOption,
            onChange: (values: string[]) => setSelectedFilter('reportTermin', 'tanggalPembayaran', values)
        },
    ];

    const fetcher = (url: string) => axios.get(url, {
        headers: {
            'X-Auth-token': token
        }
    }).then(res => res.data.data)


    const { data: products = [], isLoading: productsLoading } = useSWR(selectTemplateIdPipeline ? `${API_URL}lead-template-product-accesses/${selectTemplateIdPipeline}` : null, fetcher)
    const { data: merchantsData = [], error: merchantsError, isLoading: merchantsLoading } = useSWR(user.data.permission_merchant_read !== 'NONE' ? `${API_URL}merchants${selectTemplateIdPipeline ? `?leadTemplateId=` + selectTemplateIdPipeline : ""}` : null, fetcher)


    const handleSaveTemplateOrderCompany = async () => {
        try {
            const updateData = propsData.updatedData.updatedDataCompany.map((template, index) => ({
                ...template,
                id: template.id,
                position: index
            }));

            const response = await updateSortTemplateFilterReportTermin(updateData, token, 'company');
            if (response.data.success) {
                Swal.fire({
                    icon: 'success',
                    title: intl.formatMessage({ id: "FORM.VALIDATION.SAVE_SUCCESS" }),
                    timer: 2000,
                    timerProgressBar: true,
                });
                const sortDataByPosition = response.data.data.sort((a: any, b: any) => a.position - b.position)
                propsData.initializeData?.initializeDataCompany(sortDataByPosition)
            }
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: 'Error saving template order',
                text: error.response?.data?.message || 'An error occurred'
            });
        }
    };

    const handleSaveTemplateOrderPersonal = async () => {
        try {
            const updateData = propsData.updatedData.updatedDataPersonal.map((template, index) => ({
                ...template,
                id: template.id,
                position: index
            }));

            const response = await updateSortTemplateFilterReportTermin(updateData, token, 'personal');
            if (response.data.success) {
                Swal.fire({
                    icon: 'success',
                    title: intl.formatMessage({ id: "FORM.VALIDATION.SAVE_SUCCESS" }),
                    timer: 2000,
                    timerProgressBar: true,
                });
                const sortDataByPosition = response.data.data.sort((a: any, b: any) => a.position - b.position)
                propsData.initializeData?.initializeDataPersonal(sortDataByPosition)
            }

        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: 'Error saving template order',
                text: error.response?.data?.message || 'An error occurred'
            });
        }
    }

    const renderButton = (props: any, ref: any) => {
        return (
            <button {...props} ref={ref} className="btn btn-sm btn-light-linkedin" style={{ padding: "7px 12px", fontSize: "x-small" }}>
                <i className="fas fa-plus"></i> {intl.formatMessage({ id: "FILTER.LABEL.DATABASE.ADD" })}
            </button>
        );
    };

    const handleDateRangeChange = (value: DateRange | null) => {
        if (!value) {
            clearMasterDateRange()
            return;
        }

        const startDateTime = moment(value[0]).startOf('day');
        const endDateTime = moment(value[1]).endOf('day');

        setMasterDateRange({
            reportTermin: {
                startDate: startDateTime.toDate(),
                endDate: endDateTime.toDate()
            },
        })
        setIsMounted(true)
    };

    const handleUseTemplate = (template: ReportTerminFilter) => {
        setSelectedFilter('reportTermin', 'leadName', template.content.filter.leadName || [])
        setSelectedFilter('reportTermin', 'merchantName', template.content.filter.merchantName || [])
        setSelectedFilter('reportTermin', 'tanggalPembayaran', template.content.filter.tanggalPembayaran||[])
        setSelectDateFilter(template.content.filter_date_range)

        setIsMounted(true)
        setUserTemplateFilterReportTermin(
            (propsData.updatedData.updatedDataPersonal || userTemplateFilterReportTermin).map(item => {
                if (item.id === template.id) {
                    return {
                        ...item,
                        content: {
                            ...item.content,
                            use: true
                        }
                    }
                } else {
                    return {
                        ...item,
                        content: {
                            ...item.content,
                            use: false
                        }
                    }
                }
            })
        )

        setCompanyTemplateFilterReportTermin(
            (propsData.updatedData.updatedDataCompany || companyTemplateFilterReportTermin).map(item => {
                if (item.id === template.id) {
                    return {
                        ...item,
                        content: {
                            ...item.content,
                            use: true
                        }
                    }
                } else {
                    return {
                        ...item,
                        content: {
                            ...item.content,
                            use: false
                        }
                    }
                }
            })
        )

        propsData.updatedData.manageColumns.map((columnItem: TableColumn<ReportTerminType>) => {
            columnItem.omit = template.content.hide.includes(columnItem.id as string);
        });

        propsData.updatedData.manageColumns.sort((a: any, b: any) => {
            const indexA = template.content.sort.indexOf(a.id);
            const indexB = template.content.sort.indexOf(b.id);

            // Jika salah satu ID tidak ada dalam template, tetap di posisi awal
            if (indexA === -1 || indexB === -1) {
                return 0;
            }

            return indexA - indexB;
        });

        if (propsData.updatedData.manageColumns.filter(column => column.omit !== true).length === propsData.updatedData.manageColumns.length) {
            setSelectAllColumn(true)
        } else {
            setSelectAllColumn(false)
        }

        propsData.setUpdatedData.setManageColumns([...propsData.updatedData.manageColumns])
    }
 
    const handleUpdateUserTemplate = async (typeTemplate: string, template: ReportTerminFilter) => {
        var dataSort: string[] = []
        var dataHide: string[] = []
        propsData.updatedData.manageColumns.map(item => {
            dataSort.push(item.id as string);

            if (item.omit === true) {
                dataHide.push(item.id as string);
            }
        });

        const dataTemplate: ContentReportTerminProps = {
            hide: dataHide,
            sort: dataSort,
            use: false,
            filter: {
                leadName: [...selectedFilters['reportTermin'].leadName],
                merchantName: [...selectedFilters['reportTermin'].merchantName],
                tanggalPembayaran: [...selectedFilters['reportTermin'].tanggalPembayaran]

            },
            filter_date_range: {
                typeDateFilter: typeDateFilter,
                startDate: masterDateRange.reportTermin?.startDate as Date,
                endDate: masterDateRange.reportTermin?.endDate as Date
            },
        }

        try {
            const response = await updateTemplateFilterReportTermin(template.id, selectTemplateIdPipeline, template.name, JSON.stringify(dataTemplate), token)
            if (response.data.success) {
                Swal.fire({
                    icon: 'success',
                    heightAuto: false,
                    title: `${intl.formatMessage({ id: "FORM.VALIDATION.SAVE_SUCCESS" })}`,
                    timer: 2000,
                    timerProgressBar: true
                })

                if (typeTemplate === 'update-template-user') {
                    setUserTemplateFilterReportTermin(userTemplateFilterReportTermin.map(item => {
                        if (item.id === template.id) {
                            return {
                                ...item,
                                content: {
                                    ...dataTemplate,
                                    use: template.content.use
                                }
                            }
                        } else {
                            return item
                        }
                    }));
                } else if (typeTemplate === 'update-template-company') {
                    setCompanyTemplateFilterReportTermin(companyTemplateFilterReportTermin.map(item => {
                        if (item.id === template.id) {
                            return {
                                ...item,
                                content: {
                                    ...dataTemplate,
                                    use: template.content.use
                                }
                            }
                        } else {
                            return item
                        }
                    }));
                }
            }
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: error.response.data.message,
                confirmButtonText: 'Ok'
            });
        }
    }

    const handleCheckUseTemplate = () => {
        const reportTermin = selectedFilters.reportTermin;
        if (!reportTermin) return false;

        const hasOmittedColumns = propsData.updatedData.manageColumns.some((data: TableColumn<ReportTerminType>) => data.omit === true);
        const hasRelevantFilters =reportTermin.tanggalPembayaran?.length > 0|| reportTermin.leadName?.length > 0 || reportTermin.merchantName?.length > 0 || masterDateRange.reportTermin?.startDate;

        return hasOmittedColumns || hasRelevantFilters;
    };

    const handleClickAllColumn = () => {
        const newManageColumns = [...propsData.updatedData.manageColumns];
        newManageColumns.map((data: TableColumn<ReportTerminType>) => (data.omit = selectAllColumn));
        propsData.setUpdatedData.setManageColumns(newManageColumns);
        setSelectAllColumn(!selectAllColumn);
    }

    useEffect(() => {
        if (!productsLoading) {
            const productsData = products.map((products: Product) => ({
                value: products.name,
                label: products.name
            }));

            setProductData(productsData)
        }
    }, [products])

    useEffect(() => {
        if (!merchantsLoading) {
            setMerchantData(merchantsData.map((merchants: Merchant) => ({
                value: merchants.name,
                label: merchants.name
            })))
        }
    }, [merchantsData])


    useModalEffect({
        showModal: showDeleteTemplateModal,
        setShowModal: setShowDeleteTemplateModal,
        modalId: `delete-template-pipeline-modal-${template.id}`
    })

    useEffect(() => {
        setSelectedFilter('reportTermin', 'leadName', [])
        setSelectedFilter('reportTermin', 'merchantName', [])
        setMasterDateRange({
            reportTermin: null,
            merchant: null
        })
        setTypeDateFilter('1')
        setSelectDateFilter({} as SelectDateFilterProps)
    }, [])

    useEffect(() => {
        if (selectDateFilter?.typeDateFilter && selectDateFilter?.startDate && selectDateFilter?.endDate) {
            setMasterDateRange({
                reportTermin: {
                    startDate: new Date(selectDateFilter.startDate),
                    endDate: new Date(selectDateFilter.endDate)
                },
                merchant: null
            })
            setTypeDateFilter(selectDateFilter.typeDateFilter)
        } else {
            setMasterDateRange({
                reportTermin: null,
                merchant: null
            })
            setTypeDateFilter('1')
        }
    }, [selectDateFilter])

    useEffect(() => {
        const removeErrorClass = () => {
            const errorPickers = document.querySelectorAll('.rs-picker-error');

            errorPickers.forEach(picker => {
                picker.classList.remove('rs-picker-error');
            });
        };

        removeErrorClass();

        const intervalId = setInterval(removeErrorClass, 100);

        const handlePickerOpen = () => {
            setTimeout(removeErrorClass, 10);
        };

        document.addEventListener('click', handlePickerOpen);

        return () => {
            clearInterval(intervalId);
            document.removeEventListener('click', handlePickerOpen);
        };
    }, []);

    return (
        <div>
            {
                (handleCheckUseTemplate()) ?
                    <>
                        <button className="btn mt-3 me-3" style={{ backgroundColor: "#f1faff", border: "2px solid #009EF7", padding: "calc(0.75rem) calc(1.5rem)" }} onClick={() => setIsOpenDrawer(true)}>
                            <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2 svg-icon-primary m-0' />
                        </button>
                        <button type="button"
                            className="btn btn-white mt-3 text-primary"
                            onClick={() => { handleResetFilter() }}
                        >
                            Reset Filter
                        </button>
                    </>
                    :
                    <button type="button" className="btn btn-light mt-3" onClick={() => setIsOpenDrawer(true)}>
                        <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2 m-0' />
                    </button>
            }

            <Drawer
                className="bg-white"
                size={isMobile ? "xs" : "md"}
                placement="right"
                open={isOpenDrawer}
                onClose={() => setIsOpenDrawer(false)}
                style={{ height: "100%", overflowY: "auto" }}
            >
                <div className="card rounded-0" style={{ height: "100%" }} id="kt_drawer_filter_pipeline">
                    <div className="card-header pe-5">
                        <div className="card-title">
                            <div className="d-flex justify-content-center flex-column me-3">
                                <span className="fs-4 fw-bolder text-gray-900 text-hover-primary me-1 lh-1">Filter Termin</span>
                            </div>
                        </div>
                        <div className="card-toolbar">
                            <div className="btn btn-sm btn-icon btn-active-light-primary" onClick={() => setIsOpenDrawer(false)}>
                                <span className="svg-icon svg-icon-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black"></rect>
                                        <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black"></rect>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center">
                            <div style={{ fontWeight: "600" }}>{intl.formatMessage({ id: "FILTER.LABEL.DATABASE.LIST" })}</div>
                            <div>
                                {
                                    user.data.is_superadmin ?
                                        <Dropdown renderToggle={renderButton} title={`${intl.formatMessage({ id: 'FORM.ACTION.ADD' })} ${settings.meeting_title}`} noCaret placement="bottomEnd">
                                            <Dropdown.Item onClick={() => { setShowModifyTemplateModal(true); setType("insert-template-user") }}>Personal</Dropdown.Item>
                                            <Dropdown.Item onClick={() => { setShowModifyTemplateModal(true); setType("insert-template-company") }}>Company</Dropdown.Item>
                                        </Dropdown>
                                        :
                                        <button className="btn btn-sm btn-light-linkedin" onClick={() => { setShowModifyTemplateModal(true); setType("insert-template-user") }} style={{ padding: "7px 12px", fontSize: "x-small" }}>{intl.formatMessage({ id: "FILTER.LABEL.DATABASE.ADD" })}</button>
                                }
                            </div>
                        </div>
                        <div className="separator separator-dashed my-3"></div>
                        <div className="d-flex justify-content-between align-items-center" style={{ height: '30px' }}>
                            {
                                propsData.updatedData.updatedDataCompany.length > 0 &&
                                <small>Company</small>
                            }

                            {propsData.hasChanges?.hasChangesCompany && (
                                <button
                                    className="btn btn-sm btn-primary"
                                    onClick={handleSaveTemplateOrderCompany}
                                    style={{ padding: "7px 12px", fontSize: "x-small" }}
                                >
                                    {intl.formatMessage({ id: "FORM.ACTION.SAVE_CHANGES" })}
                                </button>
                            )}
                        </div>
                        <DndContext onDragEnd={propsData.handleDragEnd.handleDragEndCompany} sensors={propsData.sensors.sensorsCompany} collisionDetection={closestCenter}>
                            <SortableContext items={propsData.updatedData.updatedDataCompany as any} strategy={verticalListSortingStrategy}>
                                {
                                    propsData.updatedData.updatedDataCompany.map((dataCompanyTemplate: ReportTerminFilter, index) => {
                                        return (
                                            <ItemTemplateCompanyReportTermin
                                                key={index}
                                                id={dataCompanyTemplate.id}
                                                dataCompanyTemplate={dataCompanyTemplate}
                                                handleUseTemplate={handleUseTemplate}
                                                setShowModifyTemplateModal={setShowModifyTemplateModal}
                                                setType={setType}
                                                setTemplate={setTemplate}
                                                handleUpdateUserTemplate={handleUpdateUserTemplate}
                                                setShowDeleteTemplateModal={setShowDeleteTemplateModal}
                                            />
                                        )
                                    })
                                }
                            </SortableContext>
                        </DndContext>

                        <div className="d-flex justify-content-between align-items-center" style={{ height: '30px' }}>
                            {
                                propsData.updatedData.updatedDataPersonal.length > 0 &&
                                <small>Personal</small>
                            }

                            {propsData.hasChanges?.hasChangesPersonal && (
                                <button
                                    className="btn btn-sm btn-primary"
                                    onClick={handleSaveTemplateOrderPersonal}
                                    style={{ padding: "7px 12px", fontSize: "x-small" }}
                                >
                                    {intl.formatMessage({ id: "FORM.ACTION.SAVE_CHANGES" })}
                                </button>
                            )}
                        </div>
                        <DndContext onDragEnd={propsData.handleDragEnd.handleDragEndPersonal} sensors={propsData.sensors.sensorsPersonal} collisionDetection={closestCenter}>
                            <SortableContext items={propsData.updatedData.updatedDataPersonal as any} strategy={verticalListSortingStrategy}>
                                {
                                    propsData.updatedData.updatedDataPersonal.map((dataUserTemplate: ReportTerminFilter, index) => {
                                        return (
                                            <ItemTemplatePersonalReportTermin
                                                key={index}
                                                id={dataUserTemplate.id}
                                                dataUserTemplate={dataUserTemplate}
                                                handleUseTemplate={handleUseTemplate}
                                                setShowModifyTemplateModal={setShowModifyTemplateModal}
                                                setType={setType}
                                                setTemplate={setTemplate}
                                                handleUpdateUserTemplate={handleUpdateUserTemplate}
                                                setShowDeleteTemplateModal={setShowDeleteTemplateModal}
                                            />
                                        )
                                    })
                                }
                            </SortableContext>
                        </DndContext>

                        <div className="mt-10" style={{ fontWeight: "600" }}>Filter Data</div>
                        <div className="separator separator-dashed my-3"></div>
                        {
                            selectConfigs.map((config, index) => (
                                <DataTableSelect
                                    placeholder={config.placeholder}
                                    tableKey={config.tableKey}
                                    filterKey={config.filterKey}
                                    key={index}
                                    options={config.options}
                                    onChange={config.onChange}
                                    manageColumns={propsData.updatedData.manageColumns}
                                    setManageColumns={propsData.setUpdatedData.setManageColumns}
                                />
                            ))
                        }
                        <div className="mt-10" style={{ fontWeight: "600" }}>{intl.formatMessage({ id: "FORM.LABEL.MANAGE_COLUMN" })}</div>
                        <div className="separator separator-dashed my-3"></div>
                        <div className="d-flex align-items-center bg-hover-light-primary rounded-2 w-100" style={{ padding: "5px" }} onClick={handleClickAllColumn}>
                            <div className="form-check form-check-custom form-check-solid">
                                <input className="form-check-input" type="checkbox" checked={selectAllColumn} readOnly />
                            </div>
                            <span className="form-check-label fw-bolder ms-2 w-100">{intl.formatMessage({ id: "FORM.ACTION.SELECT_ALL" })}</span>
                        </div>
                        <DndContext onDragEnd={propsData.handleDragEnd.handleDragEndColumn} sensors={propsData.sensors.sensorsColumn} collisionDetection={closestCenter}>
                            <SortableContext items={propsData.updatedData.manageColumns as any} strategy={verticalListSortingStrategy}>
                                {
                                    propsData.updatedData.manageColumns.map((data: TableColumn<ReportTerminType>, index: number) => {
                                        return (
                                            <InputCheckbox
                                                key={index}
                                                id={data.id as string}
                                                manageColumns={propsData.updatedData.manageColumns}
                                                setManageColumns={propsData.setUpdatedData.setManageColumns}
                                                setSelectAllColumn={setSelectAllColumn}
                                                index={index}
                                            />
                                        )
                                    })
                                }
                            </SortableContext>
                        </DndContext>
                    </div>
                </div>
            </Drawer >

            {
                showModifyTemplateModal && <ModifyTemplateReportTermin type={type} manageColumns={propsData.updatedData.manageColumns} template={template} isOpen={showModifyTemplateModal} onClose={() => setShowModifyTemplateModal(false)} />
            }
            {
                showDeleteTemplateModal && <DeleteTemplateReportTermin type={type} template={template} reset={handleResetFilter} />
            }
        </div >
    )
}

export { FilterReportTerminMain }